/** @jsx h */
/* global H */
import { h, cloneElement, Component } from 'preact'

import { addListenersFromProps, removeListenersFromProps } from './utils/listeners'

function shallowEqual (a, b) {
  for (let key in a) if (a[key] !== b[key]) return false
  for (let key in b) if (!(key in a)) return false
  return true
}

class Map extends Component {
  handleResize = () => {
    const { map } = this.state

    map.getViewPort().resize()
  }

  componentDidMount () {
    const platform = new H.service.Platform({
      apikey: this.props.apikey,
      useHTTPS: true
    })
    const layers = platform.createDefaultLayers()
    const map = new H.Map(
        this.container,
        layers.vector.normal.map,
        {
          center: this.props.center,
          zoom: this.props.zoom
        }
    )

    /* eslint-disable no-new */
    new H.mapevents.Behavior(new H.mapevents.MapEvents(map))
    addListenersFromProps(map, this.props)

    this.setState({ map }, function () {
      window.addEventListener('resize', this.handleResize, { passive: true })
      this.props.onload()
    })
  }

  componentDidUpdate (prevProps) {
    const vm = this.state.map.getViewModel()

    if (!shallowEqual(this.props.center, prevProps.center)) {
      this.state.map.setCenter(this.props.center)
    }

    if (!(shallowEqual(this.props.viewBounds, prevProps.viewBounds))) {
      const { top, left, bottom, right } = this.props.viewBounds
      const rect = new H.geo.Rect(top, left, bottom, right)
      vm.setLookAtData({ bounds: rect })
    }

    if (this.props.zoom !== prevProps.zoom) {
      vm.setLookAtData({ zoom: Math.round(this.props['zoom']) }, true)
    }

    addListenersFromProps(this.map, this.props, {
      filter: ({ prop }) => !prevProps[prop]
    })

    removeListenersFromProps(this.map, prevProps, {
      filter: ({ prop }) => !this.props[prop]
    })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
    removeListenersFromProps(this.state.map, this.props)
  }

  render ({ children }, { map }) {
    return (
        <div style={{ width: '100%', height: '100%' }} ref={node => (this.container = node)}>
    {!!map && children.map(child => cloneElement(child, { map }))}
  </div>
  )
  }
}

export default Map
